<script setup lang="ts">
const { pricingData } = useLandingData()
</script>

<template>
  <div class="border rounded-lg border-neutral-200 overflow-hidden mt-4">
    <table class="w-full text-xs text-left">
      <thead>
        <tr>
          <th class="py-2 px-3 border border-neutral-200 font-semibold bg-primary/5">
            <span class="gradient-text">Metode Pembayaran</span>
          </th>
          <th class="py-2 px-3 border border-neutral-200 font-semibold bg-primary/5 text-center">
            <span class="gradient-text">Platform Lain</span>
          </th>
          <th class="py-2 px-3 border border-neutral-200 font-semibold bg-primary/5 text-center">
            <span class="gradient-text">Rintisan Billing</span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-neutral-200">
        <tr v-for="(item, index) in pricingData" :key="index">
          <td class="flex items-center px-3 py-2 space-x-2 border-r border-neutral-200">
            <div>
              <img
                class="h-4 w-[44px] object-contain"
                :src="item.icon"
                :alt="item.type || 'Payment Method'"
              >
              <div :class="{ 'flex gap-1 items-center mt-1': item.img1 || item.img2 }">
                <p v-if="item.type" class="text-xs mt-0.5 text-neutral-500">
                  {{ item.type }}
                </p>
                <img v-if="item.img1" :class="item.classimg1" class="h-3.5 w-[32px] object-contain" :src="item.img1" alt="">
                <img v-if="item.img2" class="h-3.5 w-[32px] object-contain" :src="item.img2" alt="">
              </div>
            </div>
          </td>
          <td class="px-3 py-2 text-xs text-center border-r text-neutral-700 border-neutral-200">
            {{ item.otherPlatform }}
          </td>
          <td class="text-center px-3 py-2">
            <div class="flex flex-col items-center gap-0.5">
              <span class="text-xs line-through text-destructive">{{ item.defaultBilling }}</span>
              <span class="text-xs font-medium text-neutral-700">{{ item.rintisanBilling }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
